import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseTag } from '../components/base-tag/Component.js';

var defaultColors = {"filled":"tag__filled_1gavh"};
require('./default.mobile.css')

var invertedColors = {"filled":"tag__filled_eregc"};
require('./inverted.mobile.css')

var styles = {"rectangular":"tag__rectangular_4fq5n","size-32":"tag__size-32_4fq5n","size-40":"tag__size-40_4fq5n","size-48":"tag__size-48_4fq5n","size-56":"tag__size-56_4fq5n","size-64":"tag__size-64_4fq5n","size-72":"tag__size-72_4fq5n"};
require('./mobile.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var TagMobile = forwardRef(function (restProps, ref) { return (React.createElement(BaseTag, __assign({}, restProps, { colorStylesMap: colorStyles, ref: ref, styles: styles }))); });

export { TagMobile };
